import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BmarkAllocationMetaData {
  public allocationIdString: string; // primary
  public allocationId: CubiqTS.Long; // primary
  public orderId: string; // reference
  public allocationType: CubiqTS.AllocationType;
  public visibleOnItsOwn: boolean;
  //
  public baseCcy: string;
  public nonBaseCcy: string;
  public traderGroupName: string;
}
